import type { ComponentProps } from "react";
import { useSearchParams } from "react-router";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { ClientsView } from "@/components/admin/clients-view";
import { useAdminView } from "@shared/client/admin-view";
import { usePageTitle } from "@shared/client/view";

type ClientsData = Pick<ComponentProps<typeof ClientsView>, "clients">;

export default function AdminClientsPage() {
  usePageTitle("Clients — Administration Hune");
  const [params] = useSearchParams();
  const { data, error } = useAdminView<ClientsData>("/api/views/admin/clients");
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <ClientsView clients={data.clients} search={params.get("search") ?? ""} status={params.get("status") ?? "all"} />;
}
